/**
 * Canonical list of MCP permission scopes. Kept in `src/lib/` so both the
 * admin frontend (which prompts the operator to select scopes when minting
 * a new token) and the server (which enforces them via assertScope() in
 * worker-mcp.ts) share the same source of truth.
 *
 * Adding a scope is two-step: append to this list AND wrap the matching
 * tool body with `assertScope(key, "new:scope")` in worker-mcp.ts.
 */
export const MCP_SCOPES = [
  "users:read",
  "users:write",
  "users:delete",
  "verifications:read",
  "verifications:write",
  "verifications:refund",
  "coupons:read",
  "coupons:write",
  "plans:read",
  "plans:write",
  "billing:read",
  "monitoring:read",
  "monitoring:write",
  "entities:read",
  "referrals:read",
] as const;

export type McpScope = (typeof MCP_SCOPES)[number];
